import config from 'uplisting-frontend/config/environment';

const BASE_URL = `https://www.airbnb.com/oauth2/auth?client_id=${config.airbnbOfficial.clientId}`;

export function getAirbnbReadLink(
  redirect = config.airbnbOfficial.redirectUri,
  state?: string,
): string {
  const base = `${BASE_URL}&scope=${config.airbnbOfficial.readOnlyScopes}&redirect_uri=${redirect}`;

  if (state) {
    return `${base}&state=${state}`;
  }

  return base;
}

export function getAirbnbFullLink(
  redirect = config.airbnbOfficial.redirectUpgradeUri,
  state?: string,
): string {
  const base = `${BASE_URL}&scope=${config.airbnbOfficial.fullAccessScopes}&redirect_uri=${redirect}`;

  if (state) {
    return `${base}&state=${state}`;
  }

  return base;
}
